import { useState, useEffect, useMemo } from 'react';
import { useUi } from '@weareconceptstudio/core';

/**
 * Custom hook for device detection that handles SSR compatibility
 * @returns {Object} Device detection information
 */
export const useDeviceDetection = () => {
	const [isClient, setIsClient] = useState(false);
	const { winWidth } = useUi();

	useEffect(() => {
		setIsClient(true);
	}, []);

	const deviceInfo = useMemo(() => {
		if (!isClient) {
			return {
				hasTouchScreen: false,
				isDesktop: false,
				isMobile: true,
			};
		}

		const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
		const isDesktop = winWidth >= 1280;
		const isMobile = !isDesktop;

		return { hasTouchScreen, isDesktop, isMobile };
	}, [isClient, winWidth]);

	return {
		isClient,
		...deviceInfo,
	};
};
